var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 105,
    viewBox: "0 0 119 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118.73 76.374C118.73 78.4412 118.323 80.4882 117.532 82.3981C116.741 84.308 115.582 86.0434 114.12 87.5052C112.658 88.967 110.923 90.1266 109.013 90.9177C107.103 91.7088 105.056 92.116 102.989 92.116H42.357C40.2897 92.1161 38.2425 91.7091 36.3325 90.918C34.4225 90.1269 32.687 88.9674 31.2251 87.5056C29.7632 86.0438 28.6036 84.3084 27.8124 82.3984C27.0212 80.4885 26.614 78.4413 26.614 76.374V15.741C26.6141 13.6737 27.0215 11.6267 27.8127 9.71686C28.6039 7.807 29.7636 6.0717 31.2254 4.61002C32.6873 3.14833 34.4228 1.98889 36.3327 1.19791C38.2427 0.406918 40.2897 -0.000131294 42.357 3.17671e-08H102.99C107.165 3.1767e-08 111.169 1.65843 114.121 4.61044C117.073 7.56245 118.731 11.5662 118.731 15.741L118.73 76.374Z",
    fill: "url(#paint0_linear_1206_2094)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.413 47.4011H0.234863V104.148H100.413V47.4011Z",
    fill: "#C2E07B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0149 18.7771L100.331 47.3901L50.0149 75.8471L0.00292969 47.4471L50.0149 18.7771Z",
    fill: "#7BBC48"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1839 26.2971H16.2129V53.4441H84.1839V26.2971Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.002 56.656V38.156L36.4619 26.426H63.2429L83.9729 38.215V56.521L49.802 75.849L16.002 56.656Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2129 26.2971H48.1609L25.4729 61.8971L16.2819 56.6701L16.2129 26.2971Z",
    fill: "#F6F6F6"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58 41.2871L42 57.2871",
    stroke: "#C7007D",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42 41.2871L58 57.2871",
    stroke: "#C7007D",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.176 75.593L100.491 104.206L0.165039 104.264L50.176 75.593Z",
    fill: "#A2D45E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1206_2094",
    x1: 38.8656,
    y1: 89.3525,
    x2: 113.756,
    y2: 4.05229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBAE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#FBC5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#FCD9EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#FCE5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFDFD"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailNotFound);
export default __webpack_public_path__ + "static/media/email_not_found.4d042ddf6d3020bd8f4b3305c9983b84.svg";
export { ForwardRef as ReactComponent };